// extracted by mini-css-extract-plugin
export default {"hsError":"RegistrationForm_hsError__6tb4j","inputHolder":"RegistrationForm_inputHolder__M-Sc2","buttonHolder":"RegistrationForm_buttonHolder__dAdLM"};